<ns-grid
  gridTitle="Administer Third Party Providers"
  name="THIRD_PARTY"
  [columns]="columnDefs"
  [data]="loaData"
  [config]="config"
  [loading]="loading"
  [gridOptions]="options"
  (selectedOption)="optionsSelected($event)"
  (refresh)="refreshGrid()"
  (ready)="setGrid($event)">
</ns-grid>
